import { useEffect, useMemo, useState } from "react";

import { useChainId } from "@/entities/chain-id/context/use-chain-id";
import { PoolName } from "@/shared/constants/pools";
import { ChartRiskLiquidity } from "@/shared/types/chart-risk";
import { ChainName } from "@/shared/types/networks";
import { request } from "@/shared/utils/request";

import { getFetchParams } from "./get-fetch-params";

const MAX_POINTS_COUNT = 1000;

export const useLiquidityChartData = (
  poolName: PoolName,
  chainName: ChainName,
) => {
  const [data, setData] = useState<ChartRiskLiquidity>();
  const chainId = useChainId();

  const params = useMemo(
    () => getFetchParams(poolName, chainName),
    [poolName, chainName],
  );

  useEffect(() => {
    if (!params || !chainId) return;
    const { address, priceDelta } = params;
    const fetchChartRisk = async () => {
      const response = await request<ChartRiskLiquidity>(
        `chain/${chainId}/pool/${address}/chart/risk/tick_liquidity?priceDeltaInToken0=${priceDelta}&maxPointsCount=${MAX_POINTS_COUNT}`,
      );
      setData(response);
    };
    fetchChartRisk();
  }, [chainId, params]);

  return { data, hasLiquidityChart: Boolean(params) };
};
